import React from 'react';
import TableList from '../shared/TableList.js';
import { formatDate } from '../../utils.js';
import translate from './translate_event.js';
import { Link } from 'react-router-dom';
import useFeatureChecker, { AllowedFeature, DeniedFeature } from '../shared/FeatureChecker.js';

export default function DigitalsTable({ logs }) {
  const CheckFeatures = useFeatureChecker()
  if (!logs.length) {
    return <div className="not-found-table-items">No se encontraron Logs</div>
  }

  return (
    <TableList>
      <TableList.Header>
        <TableList.HeaderItem value="Fecha" />
        <TableList.HeaderItem value="Evento" />
        <TableList.HeaderItem value="Source" />
        <TableList.HeaderItem value="Usuario" />
        <TableList.HeaderItem value="Plataforma" />
        <TableList.HeaderItem value="Nombre" />
      </TableList.Header>

      <TableList.Body>
        {
          logs.map(item => (
            <TableList.Row key={item.id}>
              <TableList.Column>
                <Link to={`/digitals/logs/${item.id}`}>
                  {formatDate(item.time,"dd/MM/yyyy HH:mm:ss")}
                </Link>
              </TableList.Column>
              <TableList.Column>
                {translate(item.event_name)}
              </TableList.Column>
              <TableList.Column>
                {item.source_ip}
              </TableList.Column>
              <TableList.Column>
                    {
                      item.found_user?(
                        <CheckFeatures feature = 'DETAIL_USER'>
                          <AllowedFeature>
                            <Link className="py-3" to={"/members/" + item.found_user}>
                              <span>
                                {
                                  item.platform === "GCP" ?
                                  (item.user_name): (<span> {item.user_name}<br/>({item.user_id})</span>)   
                                }
                              </span>
                            </Link>
                          </AllowedFeature>
                          <DeniedFeature>
                            <span>
                               {
                                  item.platform === "GCP" ?
                                  (item.user_name): (<span> {item.user_name}<br/>({item.user_id})</span>)   
                                }
                            </span>
                          </DeniedFeature>
                        </CheckFeatures>
                      ):<span>
                         {
                                  item.platform === "GCP" ?
                                  (item.user_name): (<span> {item.user_name}<br/>({item.user_id})</span>)   
                                }
                      </span>
                    }
              </TableList.Column>
               <TableList.Column>
                <CheckFeatures feature = 'DETAIL_IMPLEMENTATION'>
                  <AllowedFeature>
                    <Link className="py-3" to={"/digitals/implementation/" + item.octoberus_uuid}>
                      <span>
                          {
                            item.platform === "GCP" ?
                            (item.platform): (<span> {item.platform}<br/>({item.extra})</span>)   
                          }
                      </span>
                    </Link>
                  </AllowedFeature>
                  <DeniedFeature>
                    <span>
                       {item.platform} <br/>
                      {
                        item.extra?"("+item.extra+")":null
                      }
                    </span>
                  </DeniedFeature>
                </CheckFeatures>

                
              </TableList.Column>
              <TableList.Column>
                <CheckFeatures feature = 'DETAIL_IMPLEMENTATION'>
                  <AllowedFeature>
                    <Link className="py-3" to={"/digitals/implementation/" + item.octoberus_uuid}>
                      <span>{item.octoberus_name}</span>
                    </Link>
                  </AllowedFeature>
                  <DeniedFeature>
                    <span>
                      {item.octoberus_name}
                    </span>
                  </DeniedFeature>
                </CheckFeatures>
              </TableList.Column>
            </TableList.Row>
          ))
        }
      </TableList.Body>
    </TableList>
  )
}
